/* ========================================================================
   © 2026 FixMySiteKit Framework. All rights reserved.
   ======================================================================== */
import { Loader2 } from "lucide-react";

export default function DirectoryLoading({ label = "Loading directory…" }) {
    return (
        <div
            data-testid="directory-loading"
            className="mx-auto flex min-h-[40vh] max-w-4xl items-center justify-center px-6"
            aria-live="polite"
        >
            <div className="flex items-center gap-3 text-muted-foreground">
                <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" />
                <span className="text-sm">{label}</span>
            </div>
        </div>
    );
}
